






























import { Component, Emit, Prop, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { AtomButton } from '@/components/atoms'

@Component({
  components: {}
})
export default class ModalFooter extends ComponentVue {
  @Ref()
  okAtomButton!: AtomButton

  @Prop({ type: Boolean, default: false })
  printable!: boolean

  @Prop({ type: Boolean, default: false })
  cancel!: boolean

  @Prop({ type: Boolean, default: false })
  ok!: boolean

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  focusOkButton(): void {
    if (this.okAtomButton) {
      this.okAtomButton.atomButton.$el.focus()
    }
  }

  @Emit('print')
  onClickPrint(): void {}

  @Emit('cancel')
  onClickCancel(): void {}

  @Emit('ok')
  onClickOk(): void {}
}
